import { AccountingRoute } from '/@/modules/accounting/constants/AccountingRoute';
import { AccountingConnectionsRouteConfig } from '/@/modules/accounting/routes/AccountingConnectionsRouteConfig';
import { TaxesRouteConfig } from '/@/modules/accounting/routes/TaxesRouteConfig';
import { EstateDistributionRouteConfig } from '/@/modules/accounting/routes/EstateDistributionRouteConfig';
import { AccountingGenericRouteConfig } from '/@/modules/accounting/routes/AccountingGenericRouteConfig';
import { OverviewRouteConfig } from '/@/modules/accounting/routes/OverviewRouteConfig';

export const router = [
  {
    path: `/${AccountingRoute.ACCOUNTING}`,
    name: AccountingRoute.ACCOUNTING,
    component: () => import('/@/modules/accounting/pages/AccountingPage.vue'),
    children: [
      {
        name: AccountingRoute.OVERVIEW.name,
        path: '',
        redirect: AccountingRoute.OVERVIEW.path
      },
      OverviewRouteConfig.factory({
        path: AccountingRoute.OVERVIEW.path,
        name: AccountingRoute.OVERVIEW.name,
        component: () => import('/@/modules/accounting/pages/AccountingOverviewPage.vue')
      }).build(),
      AccountingGenericRouteConfig.factory({
        path: AccountingRoute.ASSETS.path,
        name: AccountingRoute.ASSETS.name,
        component: () => import('/@/modules/asset/pages/v2/AssetTablePage.vue')
      }).build(),
      AccountingGenericRouteConfig.factory({
        path: AccountingRoute.LIABILITIES.path,
        name: AccountingRoute.LIABILITIES.name,
        component: () => import('/@/modules/liability/pages/v2/LiabilityTablePage.vue')
      }).build(),
      AccountingConnectionsRouteConfig.factory({
        path: AccountingRoute.CONNECTIONS.path,
        name: AccountingRoute.CONNECTIONS.name,
        component: () => import('/@/modules/financialaccount/pages/LinkedAccountListPage.vue')
      }).build(),
      AccountingGenericRouteConfig.factory({
        path: AccountingRoute.CASHFLOWS.path,
        name: AccountingRoute.CASHFLOWS.name,
        component: () =>
          import('/@/modules/financialaccount/pages/v2/LinkedAccountCashflowListPage.vue')
      }).build(),
      AccountingGenericRouteConfig.factory({
        path: AccountingRoute.ACCOUNTING_TAB.path,
        name: AccountingRoute.ACCOUNTING_TAB.name,
        component: () => import('/@/modules/accounting/pages/AccountingTabPage.vue')
      }).build(),
      TaxesRouteConfig.factory({
        path: AccountingRoute.TAXES.path,
        name: AccountingRoute.TAXES.name,
        component: () => import('/@/modules/tax/pages/TaxesPage.vue')
      }).build(),
      EstateDistributionRouteConfig.factory({
        path: AccountingRoute.ESTATE_DISTRIBUTION.path,
        name: AccountingRoute.ESTATE_DISTRIBUTION.name,
        component: () => import('/@/modules/estatedistribution/pages/EstateDistributionPage.vue')
      }).build()
    ]
  }
];
